import { GameConstants } from "../GameConstants";

import { Board } from "./Board";

import { GameVars } from "../GameVars";

import { AudioManager } from "../AudioManager";

import { SponsorManager, WhyCallAd } from "../SponsorManager";

import { BoardManagerAI } from "./BoardManagerAI";
import { RectangleWithRadius } from "../utils/RectangleWithRadius";
import { GameManager } from "../GameManager";

export class EndGameLayer extends Phaser.Group {

    private buttonsBlocked: boolean;
    private menuContainer: Phaser.Group;

    constructor(game: Phaser.Game) {

        super(game, null, "pause-layer");

        this.buttonsBlocked = false;

        const darkLayer = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        darkLayer.scale.set(GameConstants.GAME_WIDTH / 64, GameConstants.GAME_HEIGHT / 64);
        darkLayer.alpha = .3;
        darkLayer.inputEnabled = true;
        darkLayer.events.onInputDown.add(this.onDownDarkLayer, this);
        this.add(darkLayer);

        this.menuContainer = new Phaser.Group(this.game);
        this.menuContainer.x = GameConstants.GAME_WIDTH / 2;
        this.menuContainer.y = Board.BOARD_PY - 15 * GameVars.scaleY;
        this.menuContainer.scale.y = GameVars.scaleY;
        this.add(this.menuContainer);

        let w = 560;
        let h = 610;
        
        const menuBackground = new RectangleWithRadius(this.game,
        -w / 2, -356, w, h, 14, GameConstants.TEXT_COLOR_BLACK, .9, RectangleWithRadius.NORMAL_CONFIGURATION);
        this.menuContainer.add(menuBackground);

        h = 140;

        const menuTitle = new Phaser.Text(this.game, 0, -350, "", { font: "60px Roboto Slab Bold",  fill: "#F6F9EF", align: "center"}); 
        menuTitle.anchor.x = .5;
        this.menuContainer.add(menuTitle);

        let winningReasonLabel: Phaser.Text;

        if (GameVars.chess.in_stalemate()) {

            menuTitle.text = "Stalemate";

        } else if (GameVars.chess.in_checkmate()) {

            menuTitle.text = GameVars.colorPlayer === GameVars.currentTurn ? GameVars.texts[GameVars.language]["YOU LOSE"] : GameVars.texts[GameVars.language]["YOU WIN"];

            winningReasonLabel = new Phaser.Text(this.game, 0, -288, GameVars.texts[GameVars.language]["Checkmate"], { font: "32px Roboto Slab Bold", fill: "#F6F9EF", align: "center"}); 
            winningReasonLabel.anchor.x = .5;
            this.menuContainer.add(winningReasonLabel);

        } else {

            menuTitle.text = GameVars.texts[GameVars.language]["YOU LOSE"];

            winningReasonLabel = new Phaser.Text(this.game, 0, -288, GameVars.texts[GameVars.language]["YOU RESIGNED"], { font: "32px Roboto Slab Bold", fill: "#F6F9EF", align: "center"}); 
            winningReasonLabel.anchor.x = .5;
            this.menuContainer.add(winningReasonLabel);
        }
    
        const totalTimeLabel = new Phaser.Text(this.game, 0, -48, GameVars.texts[GameVars.language]["TOTAL TIME"] + " - " + GameVars.formatTime(GameVars.time, true), { font: "30px Roboto Slab Regular", fill: GameConstants.TEXT_COLOR_WHITE, align: "center"}); 
        totalTimeLabel.anchor.set(.5);
        this.menuContainer.add(totalTimeLabel);
    
        const totalMovesLabel = new Phaser.Text(this.game, 0, 0, GameVars.texts[GameVars.language]["TOTAL MOVES"] + " - " + GameVars.getMoves(), { font: "30px Roboto Slab Regular", fill: GameConstants.TEXT_COLOR_WHITE, align: "center"}); 
        totalMovesLabel.anchor.set(.5);
        this.menuContainer.add(totalMovesLabel);
        
        // LOS AVATARES
        let playerAvatarImage: Phaser.Image;

        if (GameVars.avatarsLoaded) {
            playerAvatarImage = new Phaser.Image(this.game, -85, -152, "player-avatar");
        } else {
            playerAvatarImage = new Phaser.Image(this.game, -85, -152, "texture_atlas_1", "default-avatar.png");
        }
        
        playerAvatarImage.scale.set(82 / playerAvatarImage.width * .8);
        playerAvatarImage.anchor.set(.5);
        this.menuContainer.add(playerAvatarImage);

        const playerNameLabel = new Phaser.Text(this.game, -85, -112, GameVars.texts[GameVars.language]["PLAYER"], { font: "20px Roboto Slab Regular", fill: GameConstants.TEXT_COLOR_WHITE, align: "center"}); 
        playerNameLabel.anchor.x = .5;
        this.menuContainer.add(playerNameLabel);

        let adversaryAvatarImage = new Phaser.Image(this.game, 85, -152, "texture_atlas_1", "avatar-computer.png");
        adversaryAvatarImage.scale.set(82 / adversaryAvatarImage.width * .8);
        adversaryAvatarImage.anchor.set(.5);
        this.menuContainer.add(adversaryAvatarImage);

        const adversaryNameLabel = new Phaser.Text(this.game, 85, -112, GameVars.texts[GameVars.language]["COMPUTER"], { font: "20px Roboto Slab Regular", fill: GameConstants.TEXT_COLOR_WHITE, align: "center"}); 
        adversaryNameLabel.anchor.x = .5;
        this.menuContainer.add(adversaryNameLabel);

        let crownTextureName: string;
        let crown: Phaser.Image;

        if (GameVars.chess.in_checkmate()) {

            if (GameVars.colorPlayer === GameVars.currentTurn) {
                    // AI gana
                    if (GameVars.colorPlayer === GameConstants.WHITE) {
                        crownTextureName = "black_winner.png";
                    } else {
                        crownTextureName = "white_winner.png";
                    }

                    crown = new Phaser.Image(this.game, 85, -190, "texture_atlas_1", crownTextureName);
                    crown.anchor.set(.5, 1);
                    this.menuContainer.add(crown);

            } else {

                    if (GameVars.colorPlayer === GameConstants.WHITE) {
                        crownTextureName = "white_winner.png";
                    } else {
                        crownTextureName = "black_winner.png";
                    }

                    crown = new Phaser.Image(this.game, -85, -190, "texture_atlas_1", crownTextureName);
                    crown.anchor.set(.5, 1);
                    this.menuContainer.add(crown);
            }

        } else if (!GameVars.chess.in_stalemate()) {

            // el jugador se ha rendido
            if (GameVars.colorPlayer === GameConstants.WHITE) {
                crownTextureName = "black_winner.png";
            } else {
                crownTextureName = "white_winner.png";
            }

            crown = new Phaser.Image(this.game, 85, -190, "texture_atlas_1", crownTextureName);
            crown.anchor.set(.5, 1);
            this.menuContainer.add(crown);
        }
        
        // LOS BOTONES DEL MENU
        const rematchButton = new Phaser.Button(this.game, 0, 80, "texture_atlas_2_" + GameVars.language, this.onClickRematch, this);
        rematchButton.setFrames("button_rematch_on.png", "button_rematch_off.png", "button_rematch_on.png");
        rematchButton.forceOut = true;
        rematchButton.anchor.set(.5);
        this.menuContainer.add(rematchButton); 

        const homeButton = new Phaser.Button(this.game, 0, 184, "texture_atlas_2_" + GameVars.language, this.onClickHome, this);
        homeButton.setFrames("button_home_big_on.png", "button_home_big_off.png", "button_home_big_on.png");
        homeButton.forceOut = true;
        homeButton.anchor.set(.5);
        this.menuContainer.add(homeButton); 

        this.alpha = 0;

        this.game.add.tween(this)
            .to({alpha: 1}, 400, Phaser.Easing.Cubic.Out, true, 750);
    }

    public showFinishedGameData(): void {
            
        const menuTitle = new Phaser.Text(this.game, 0, -350, "", { font: "60px Roboto Slab Bold", fill: "#F6F9EF", align: "center"}); 
        menuTitle.anchor.x = .5;
        this.menuContainer.add(menuTitle);

        const totalTimeLabel = new Phaser.Text(this.game, 0, -48, "TOTAL TIME - " + GameVars.formatTime(GameVars.time, true), { font: "30px Roboto Slab Regular", fill: GameConstants.TEXT_COLOR_WHITE, align: "center"}); 
        totalTimeLabel.anchor.set(.5);
        this.menuContainer.add(totalTimeLabel);

        const totalMovesLabel = new Phaser.Text(this.game, 0, 0, "TOTAL MOVES - " + GameVars.moves, { font: "30px Roboto Slab Regular", fill: GameConstants.TEXT_COLOR_WHITE, align: "center"}); 
        totalMovesLabel.anchor.set(.5);
        this.menuContainer.add(totalMovesLabel);
        
        AudioManager.setMusicVolume(1);
    }

    private onClickRematch(): void {

        if (this.buttonsBlocked) {
            return;
        }
        
        this.buttonsBlocked = true;
        
        if (GameVars.againstAI) {
            if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
                if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                    gdsdk.showAd();
                    GameVars.typeAd = "Reset";
                } else {
                    GameManager.rematch();
                }
            } else {
                SponsorManager.adFilter(() => {
                    GameManager.rematch();
                }, this.game, WhyCallAd.onClickRetry);
            }  
        }
        
        AudioManager.playSound("click"); 
    }

    private onClickHome(): void {

        if (this.buttonsBlocked) {
            return;
        }

        this.buttonsBlocked = true;

        if (GameVars.againstAI) {
            if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
                if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                    gdsdk.showAd();
                    GameVars.typeAd = "MainMenu";
                } else {
                    BoardManagerAI.leaveRoom();
                }
            } else {
                SponsorManager.adFilter(() => {
                    BoardManagerAI.leaveRoom(true);
                }, this.game, WhyCallAd.onClickHome);
            }
        }
        
        AudioManager.playSound("click"); 
    }

    private onDownDarkLayer(): void {
        //
    }
}
